<template>
  <el-container>
    <el-main class="home_main">
      <div class="backgroundImg" style="width: 100%">
        <div style="background-color: rgba(33, 20, 20, 0.4);">
          <el-row>
            <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6" style="height: 80px;line-height: 80px">
              <div style="margin-left: 35px">
                <img src="static/images/login_logo.svg" @click="$router.push('/')"
                     style="height: 54px;top: 7px;position: absolute;z-index: 99"
                />
              </div>
              <el-row>
                <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
                  <div style="text-align: right;margin-right: 30px">
                    <i class="el-icon-s-fold" style="color:#FFFFFF" @click="drawer = true"></i>
                    <el-drawer
                      title="我是标题"
                      :visible.sync="drawer"
                      :with-header="false">
                      <div style="display: inline-block;" v-if="userInfo.id">
                        <span style="color: black;">{{ userInfo.userName }}</span>
                        <div style="display: inline-block;">
                          <el-dropdown trigger="click" style="margin-right: 10px;" @command="handleCommand">
                            <i style="font-size: 1.1rem;cursor: pointer;margin-top: 5px;color: black"
                               class="el-icon-caret-bottom"></i>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item command="logout">退出</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <!--                    <div style="text-align: center" @click="showProducts(showProduct)">产品</div>-->
                      <div style="text-align: center" @click="$router.push('/appMarket')">数转优场</div>
                      <div style="text-align: center" @click="$router.push('/successCase')">成功案例</div>
                      <div style="text-align: center" v-if="userInfo.userType==='1'" @click="goToManage()">开放平台</div>
                      <div style="text-align: center" @click="$router.push('/support')">支持与服务</div>
                      <div style="text-align: center" v-if="!userInfo.id" @click="$router.push('/login')">登录</div>
                      <div style="text-align: center" v-if="!userInfo.id" @click="$router.push('/register')">免费注册</div>
                    </el-drawer>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="0" :sm="11" :md="11" :lg="11" :xl="11">
              <el-button class="btn" @click="showProducts(showProduct)">产品</el-button>
              <el-button class="btn" style="margin-left: 5.5%;" @click="$router.push('/appMarket')">数转优场</el-button>
              <el-button class="btn" style="margin-left: 5.5%;" @click="$router.push('/successCase')">成功案例</el-button>
              <el-button class="btn" style="margin-left: 5.5%;" v-if="userInfo.userType==='1'" @click="goToManage()">
                开放平台
              </el-button>
              <el-button class="btn" style="margin-left: 5.5%;" @click="$router.push('/support')">支持与服务</el-button>
            </el-col>
            <el-col :xs="0" :sm="7" :md="7" :lg="7" :xl="7" style="text-align: right">
              <el-button class="btn" v-if="userInfo.id" @click="$router.push('/personalCenter')">消息</el-button>
              <el-button class="btn" v-if="userInfo.id" style="margin-left:2.3%;" @click="$router.push('/workbench')">
                工作台
              </el-button>
              <div style="display: inline-block;margin-left: 2.3%" v-if="userInfo.id">
                <img src="static/images/person_img.png" style="height: 26px;top: 35%;position:absolute;width: 26px;">
                <span style="color: white;margin-left:  40px">{{ userInfo.userName }}</span>
                <div style="display: inline-block;">
                  <el-dropdown trigger="click" style="margin-right: 10px;" @command="handleCommand">
                    <i style="font-size: 1.1rem;cursor: pointer;margin-top: 5px;color: white"
                       class="el-icon-caret-bottom"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="logout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <el-button class="btn" style="margin-left:  2.3%;" v-if="!userInfo.id" @click="$router.push('/login')">
                登录
              </el-button>
              <el-button class="btn" style="margin-left:  2.3%;" v-if="!userInfo.id" @click="$router.push('/register')">
                免费注册
              </el-button>
            </el-col>
          </el-row>
        </div>

        <div>
          <div v-if="showProduct"
               style="position: absolute;z-index: 2000;width: 100%;color:#000000;background-color: #FFFFFF;">
            <el-row>
              <el-col :span="5">
                <el-row>
                  <el-col :span="4">&nbsp;</el-col>
                  <el-col :span="20">
                    <div>
                      <div style="margin-top: 10px;">
                        <el-button class="productbtn" @click="checkProduct(0)">行业级产品</el-button>
                        <br/>
                        <el-button class="productbtn" @click="checkProduct(2)">软硬集成产品</el-button>
                        <br/>
                        <el-button class="productbtn" @click="checkProduct(1)">平台级产品</el-button>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="1">
                &nbsp;
              </el-col>
              <el-col :span="18">
                <div v-if="showCheckProduct2" style="margin-top: 20px">
                  <div class="topFont">晓帆低代码开发平台</div>
                  <div class="topFont">晓帆流程管理平台</div>
                </div>
                <div v-if="showCheckProduct1">
                  <div style="font-size: 18px;font-weight: bold;margin-top: 10px;color: #0aa4f8;" class="fonts_family">
                    行业专属
                  </div>
                  <el-row style="margin-top: 20px">
                    <el-col :span="5">
                      <div>
                        <span style="font-weight: bold;" class="fonts_family">化工行业</span>
                        <div class="topFont">化工企业安全风险智能管控平台</div>
                        <div class="topFont">化工企业HSE管理平台</div>
                      </div>
                    </el-col>
                    <el-col :span="1">&nbsp;</el-col>
                    <el-col :span="5">
                      <div>
                        <span style="font-weight: bold;" class="fonts_family">钢铁行业</span>
                        <div class="topFont">钢铁企业安全风险智能管控平台</div>
                        <div class="topFont">钢铁企业HSE管理平台</div>
                      </div>
                    </el-col>
                    <el-col :span="1">&nbsp;</el-col>
                    <el-col :span="5">
                      <div>
                        <span style="font-weight: bold;" class="fonts_family">工贸行业</span>
                        <div class="topFont">工贸企业安全生产管理平台</div>
                      </div>
                    </el-col>
                    <el-col :span="5">
                      <div>
                        <span style="font-weight: bold;" class="fonts_family">服装纺织</span>
                        <div class="topFont">服装订单全流程管理系统</div>
                        <div class="topFont">在线定制运营管理系统</div>
                      </div>
                    </el-col>
                    <el-col :span="1">&nbsp;</el-col>
                  </el-row>
                  <el-divider></el-divider>
                  <div style="margin-top: 10px;padding: 0 0 10px 0">
                    <span style="font-size: 18px;font-weight: bold;color: #0aa4f8;" class="fonts_family">行业通用</span>
                    <div class="topFont">企业智能巡检系统</div>
                    <div class="topFont">企业人员定位管理系统</div>
                    <div class="topFont">企业特殊作业管理系统</div>
                    <div class="topFont">企业双重预防机制数字化平台</div>
                    <div class="topFont">企业在线学习考试平台</div>
                    <div class="topFont">企业风险监测AI预警平台</div>
                  </div>
                </div>
                <div v-if="showCheckProduct3">
                  <div class="topFont">
                    <span style="font-size: 18px;font-weight: bold;color: #0aa4f8;" class="fonts_family">全场景定位</span>
                    <div class="topFont">蓝牙+LORA融合定位</div>
                    <div class="topFont">UWB高精度定位</div>
                    <div class="topFont">北斗/GPS差分定位</div>
                  </div>
                  <!--                  <div class="topFont">防爆手机</div>-->
                </div>
              </el-col>
            </el-row>
            <div></div>
          </div>
          <el-carousel style="height: 348px" indicator-position="outside" class="el-carousel_item">
            <el-row>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                &nbsp;
              </el-col>
              <el-col :xs="0" :sm="21" :md="21" :lg="21" :xl="21">
                <div style="margin-top: 4.2%;z-index: 99">
                  <div style="color: #FFFFFF;font-size: 34px;margin-top: 114px"
                       class="fonts_family">打造智慧工厂数字化整体解决方案
                  </div>
                  <div style="color: #FFFFFF;font-size: 34px;margin-top: 20px;"
                       class="fonts_family">助力企业构筑数字化时代新优势
                  </div>
                </div>
              </el-col>
              <el-col :xs="18" :sm="0" :md="0" :lg="0" :xl="0">
                <div style="margin-top: 4.2%;z-index: 99;text-align: center">
                  <div style="color: #FFFFFF;font-size: 28px;margin-top: 52px;display: inline-block; text-align: left"
                       class="fonts_family">打造智慧工厂数字化<br/>整体解决方案
                  </div>
                  <div style="color: #FFFFFF;font-size: 28px;margin-top: 20px;display: inline-block; text-align: left"
                       class="fonts_family">助力企业构筑数字化<br/>时代新优势
                  </div>
                </div>
              </el-col>
              <el-col :xs="3" :sm="0" :md="0" :lg="0" :xl="0">
                &nbsp;
              </el-col>
            </el-row>

            <el-carousel-item v-for="item in 3" :key="item">
              <!--              <img :src="item" alt="暂无图片"/>-->
              <h3></h3>
            </el-carousel-item>
          </el-carousel>

          <el-row>
            <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="carousel_bottom">
                <div class="carousel_bottom_item">
                  <div style="margin-top: 35px" class="fonts_family">企业安全生产管理应用</div>
                  <div style="color: #0aa4f8;margin-top: 28px" class="fonts_family">热品速递</div>
                </div>
                <div class="carousel_bottom_item">
                  <div style="margin-top: 35px" class="fonts_family">晓帆低代码开放平台上线</div>
                  <div style="color: #0aa4f8;margin-top: 28px" class="fonts_family">免费体验</div>
                </div>
                <div class="carousel_bottom_item">
                  <div style="margin-top: 35px" class="fonts_family">企业订单全流程管理应用</div>
                  <div style="color: #0aa4f8;margin-top: 28px" class="fonts_family">限时试用</div>
                </div>
                <div class="carousel_bottom_item">
                  <div style="margin-top: 35px" class="fonts_family">晓帆合作伙伴发展计划</div>
                  <div style="color: #0aa4f8;margin-top: 28px" class="fonts_family">渠道招募</div>
                </div>
              </div>
            </el-col>
          </el-row>


        </div>
      </div>

      <div style="margin-bottom: 40px">
        <el-row>
          <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
            <div
              style="letter-spacing:2px;font-size: 34px;font-family: Source Han Sans CN,sans-serif;font-weight: 400;color: #333333;line-height: 90px;margin-top: 46px;text-align: center;"
              class="fonts_family">
              覆盖全国的工业互联网
            </div>
          </el-col>
          <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
            <div
              style="letter-spacing:2px;font-size: 34px;color: #333333;text-align:center;margin-top: 65px;"
              class="fonts_family">
              覆盖全国的工业互联网
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: -34px">
          <el-col :xs="0" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
          <el-col :xs="0" :sm="17" :md="17" :lg="17" :xl="17">
            <div id="china-map" style="height: 870px;">
              &nbsp;
            </div>
          </el-col>
          <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
            <div id="china-map-phone" style="height: 870px;top: -240px">
              &nbsp;
            </div>
          </el-col>
          <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">&nbsp;</el-col>
          <el-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5">
            <div style="margin-top: 110px">
              <img src="static/images/home_icon1.png" class="map_img"/>
              <div style="display: inline-block;font-size: 14px;line-height: 44px;;font-weight: 400;margin-left: 10px;"
                   class="fonts_family">
                <span>已连接工厂</span><br/><span class="map_font">{{ form.gcsl }}</span>&nbsp;个
              </div>
              <br/><br/><br/>
              <img src="static/images/home_icon2.png" class="map_img"/>
              <div style="display: inline-block;font-size: 14px;line-height: 44px;;font-weight: 400;margin-left: 10px;"
                   class="fonts_family">
                <span>已连接设备数</span><br/><span class="map_font">{{ form.sbsl }}</span>&nbsp;个
              </div>
              <br/><br/><br/>
              <img src="static/images/home_icon3.png" class="map_img"/>
              <div style="display: inline-block;font-size: 14px;line-height: 44px;;font-weight: 400;margin-left: 10px;"
                   class="fonts_family">
                <span>用户数</span><br/><span class="map_font">{{ form.yhs }}</span>&nbsp;人
              </div>
              <br/><br/><br/>
              <img src="static/images/home_icon4.png" class="map_img"/>
              <div style="display: inline-block;font-size: 14px;line-height: 44px;;font-weight: 400;margin-left: 10px;"
                   class="fonts_family">
                <span>云应用数</span><br/><span class="map_font">{{ form.yyys }}</span>&nbsp;个
              </div>
              <br/><br/><br/>
              <img src="static/images/home_icon5.png" class="map_img"/>
              <div style="display: inline-block;font-size: 14px;line-height: 44px;;font-weight: 400;margin-left: 10px;"
                   class="fonts_family">
                <span>微服务数</span><br/><span class="map_font">{{ form.wfws }}</span>&nbsp;个
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
            <div style="text-align: center;margin-top: -480px">
              <el-row>
                <el-col :xs="12" :sm="0" :md="0" :lg="0" :xl="0">
                  <img src="static/images/home_icon1.png" class="map_img"/>
                  <div style="font-size: 14px;line-height: 44px;;font-weight: 400;"
                       class="fonts_family">
                    <span>已连接工厂</span><br/><span class="map_font">{{ form.gcsl }}</span>&nbsp;个
                  </div>
                </el-col>
                <el-col :xs="12" :sm="0" :md="0" :lg="0" :xl="0">
                  <img src="static/images/home_icon2.png" class="map_img"/>
                  <div style="font-size: 14px;line-height: 44px;;font-weight: 400;"
                       class="fonts_family">
                    <span>已连接设备数</span><br/><span class="map_font">{{ form.sbsl }}</span>&nbsp;个
                  </div>
                </el-col>
                <el-col :xs="12" :sm="0" :md="0" :lg="0" :xl="0" style="margin-top: 20px">
                  <img src="static/images/home_icon3.png" class="map_img"/>
                  <div style="font-size: 14px;line-height: 44px;;font-weight: 400;"
                       class="fonts_family">
                    <span>用户数</span><br/><span class="map_font">{{ form.yhs }}</span>&nbsp;人
                  </div>
                </el-col>
                <el-col :xs="12" :sm="0" :md="0" :lg="0" :xl="0" style="margin-top: 20px">
                  <img src="static/images/home_icon4.png" class="map_img"/>
                  <div style="font-size: 14px;line-height: 44px;;font-weight: 400;"
                       class="fonts_family">
                    <span>云应用数</span><br/><span class="map_font">{{ form.yyys }}</span>&nbsp;个
                  </div>
                </el-col>
                <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0" style="margin-top: 20px">
                  <img src="static/images/home_icon5.png" class="map_img"/>
                  <div style="font-size: 14px;line-height: 44px;;font-weight: 400;"
                       class="fonts_family">
                    <span>微服务数</span><br/><span class="map_font">{{ form.wfws }}</span>&nbsp;个
                  </div>
                </el-col>
              </el-row>

            </div>
          </el-col>
        </el-row>
      </div>

      <div class="home_bottom">
        <el-row>
          <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
          <div style="font-size: 34px;margin-top:54px;color:white;letter-spacing:2px;" class="fonts_family">
            丰富的云服务产品&nbsp;&nbsp;赋能企业数字化转型
          </div>
          </el-col>
          <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
            <div style="font-size: 34px;margin-top:54px;color:white;letter-spacing:2px;" class="fonts_family">
              丰富的云服务产品
              <br/>
              赋能企业数字化转型
            </div>
          </el-col>
        </el-row>
        <div style="margin-top: 55px;">
          <el-row>
            <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">
              <div
                style="height:350px;margin-bottom: 40px;background-image: url('static/images/home_bottom2.png');background-size: 100% 100%;">
                <transition :transition="20000" name="el-zoom-in-bottom">
                  <div :class="msgData[0].msgbackground"></div>
                </transition>
                <div style="position: absolute;height: 350px;width:15.94%;z-index: 2" @mouseenter="showMsg(0)"
                     @mouseleave="closeMsg(0)">
                  <img :class="msgData[0].msgImg" :src="msgData[0].img">
                  <div v-if="!msgData[0].isShow"
                       style="text-align:center;width: 100%;font-weight: bolder;font-size: 25px;color: #FFFFFF;writing-mode: vertical-lr;display: flex;
                flex-direction: column;margin-top: 7px;;
                -webkit-display:flex;
                justify-content: center;">
                    <div style="margin-top: 30px;margin-left: 30%;">...</div>
                  </div>
                  <br/>
                  <span style="color: white;font-size: 20px;letter-spacing: 2px"
                        class="fonts_family">{{ msgData[0].title }}</span><br/>
                  <transition :transition="20000" name="el-zoom-in-bottom">
                    <div v-show="msgData[0].isShow"
                         class="fonts_family msgFont">
                      {{ msgData[0].message }}
                    </div>
                  </transition>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
              <div>
                <img :src="msgData[0].img">
                <br/>
                <span style="color: white;font-size: 20px;letter-spacing: 2px"
                      class="fonts_family">{{ msgData[0].title }}</span><br/>
                <transition :transition="20000" name="el-zoom-in-bottom">
                  <div class="fonts_family msgFont">
                    {{ msgData[0].message }}
                  </div>
                </transition>
              </div>
            </el-col>
            <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">
              <div
                style="height:350px;background-image: url('static/images/home_bottom2.png');background-size: 100% 100%;">
                <transition :transition="20000" name="el-zoom-in-bottom">
                  <div :class="msgData[1].msgbackground"></div>
                </transition>
                <div style="position: absolute;width:15.94%;height: 350px;z-index: 2" @mouseenter="showMsg(1)"
                     @mouseleave="closeMsg(1)">
                  <img :class="msgData[1].msgImg" :src="msgData[1].img">
                  <div v-if="!msgData[1].isShow"
                       style="text-align:center;width: 100%;font-weight: bolder;font-size: 25px;color: #FFFFFF;writing-mode: vertical-lr;display: flex;
                flex-direction: column;margin-top: 7px;;
                -webkit-display:flex;
                justify-content: center;">
                    <div style="margin-top: 30px;margin-left: 30%;">...</div>
                  </div>
                  <br/>
                  <span style="color: white;font-size: 20px" class="fonts_family">{{
                      msgData[1].title
                    }}</span><br/>
                  <transition style="transition-duration:2s;" name="el-zoom-in-bottom">
                    <div v-show="msgData[1].isShow"
                         class="fonts_family msgFont">{{
                        msgData[1].message
                      }}
                    </div>
                  </transition>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
              <div>
                <img :src="msgData[1].img">
                <br/>
                <span style="color: white;font-size: 20px;letter-spacing: 2px"
                      class="fonts_family">{{ msgData[1].title }}</span><br/>
                <transition :transition="20000" name="el-zoom-in-bottom">
                  <div class="fonts_family msgFont">
                    {{ msgData[1].message }}
                  </div>
                </transition>
              </div>
            </el-col>
            <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">
              <div
                style="height:350px;background-image: url('static/images/home_bottom3.png');background-size: 100% 100%;">
                <transition style="transition-duration:2s;" name="el-zoom-in-bottom">
                  <div :class="msgData[2].msgbackground">
                  </div>
                </transition>
                <div style="position: absolute;width:15.94%;height: 350px;z-index: 2" @mouseenter="showMsg(2)"
                     @mouseleave="closeMsg(2)">
                  <img :class="msgData[2].msgImg" :src="msgData[2].img">
                  <div v-if="!msgData[2].isShow"
                       style="text-align:center;width: 100%;font-weight: bolder;font-size: 25px;color: #FFFFFF;writing-mode: vertical-lr;display: flex;
                flex-direction: column;margin-top: 7px;;
                -webkit-display:flex;
                justify-content: center;">
                    <div style="margin-top: 30px;margin-left: 30%;">...</div>
                  </div>
                  <br/>
                  <span style="color: white;font-size: 20px;" class="fonts_family">{{
                      msgData[2].title
                    }}</span><br/>
                  <transition style="transition-duration:2s;" name="el-zoom-in-bottom">
                    <div v-show="msgData[2].isShow"
                         class="fonts_family msgFont">{{
                        msgData[2].message
                      }}
                    </div>
                  </transition>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
              <div>
                <img :src="msgData[2].img">
                <br/>
                <span style="color: white;font-size: 20px;letter-spacing: 2px"
                      class="fonts_family">{{ msgData[2].title }}</span><br/>
                <transition :transition="20000" name="el-zoom-in-bottom">
                  <div class="fonts_family msgFont">
                    {{ msgData[2].message }}
                  </div>
                </transition>
              </div>
            </el-col>
            <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">
              <div
                style=" height:350px;background-image: url('static/images/home_bottom4.png');background-size: 100% 100%;">
                <transition style="transition-duration:2s;" name="el-zoom-in-bottom">
                  <div :class="msgData[3].msgbackground"></div>
                </transition>
                <div style="position: absolute;width:15.94%;height: 350px;z-index: 2" @mouseenter="showMsg(3)"
                     @mouseleave="closeMsg(3)">
                  <img :class="msgData[3].msgImg" :src="msgData[3].img">
                  <div v-if="!msgData[3].isShow"
                       style="text-align:center;width: 100%;font-weight: bolder;font-size: 25px;color: #FFFFFF;writing-mode: vertical-lr;display: flex;margin-top: 7px;;
                flex-direction: column;
                -webkit-display:flex;
                justify-content: center;">
                    <div style="margin-top: 30px;margin-left: 30%;">...</div>
                  </div>
                  <br/>
                  <span style="color: white;font-size: 20px" class="fonts_family">{{
                      msgData[3].title
                    }}</span><br/>
                  <transition style="transition-duration:2s;" name="el-zoom-in-bottom">
                    <div v-show="msgData[3].isShow"
                         class="fonts_family msgFont">{{
                        msgData[3].message
                      }}
                    </div>
                  </transition>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
              <div>
                <img :src="msgData[3].img">
                <br/>
                <span style="color: white;font-size: 20px;letter-spacing: 2px"
                      class="fonts_family">{{ msgData[3].title }}</span><br/>
                <transition :transition="20000" name="el-zoom-in-bottom">
                  <div class="fonts_family msgFont">
                    {{ msgData[3].message }}
                  </div>
                </transition>
              </div>
            </el-col>
            <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
          </el-row>
        </div>
      </div>

      <el-row>
        <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="home_feet" style="height: 240px">
            <el-row>
              <div style="font-size: 34px;color:white;margin-top: 76px;letter-spacing:2px;height: 34px"
                   class="fonts_family">
                现在开始, 拥抱工业互联网
              </div>
            </el-row>
            <img @click="$router.push('/register')" src="static/images/register_btn.png"
                 style="height: 42px;width: 160px;margin-top: 53px;"/>
          </div>
        </el-col>
      </el-row>

      <div class="support_bottom">
        <br>
        <el-row style="text-align: center;">
          <el-col :xs="0" :sm="3" :md="3" :lg="3" :xl="3">
            &nbsp;
          </el-col>
          <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18" style="color: white">
            <el-row style="height: 90px;">
              <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
                <div style="height: 90px;margin-top: 25px">
                  <div style="display: inline-block;font-size: 20px;font-weight: 100" class="fonts_family">
                    <div>市场商务</div>
                    <div>16712565433</div>
                  </div>
                  <div style="display: inline-block;font-size: 20px;font-weight: 100" class="fonts_family">
                    <div>客服热线</div>
                    <div>400-615-1888</div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="0" :sm="12" :md="12" :lg="12" :xl="12">
                <el-row style="margin-top: 30px">
                  <el-col :span="2">
                    <el-divider direction="vertical"></el-divider>
                  </el-col>
                  <el-col :span="20">
                    <div style="line-height: 45px">
                      <el-link style="font-size: 17px" @click="$router.push('/support')" class="fonts_family">客户成功中心
                      </el-link>&nbsp;&nbsp;
                      <el-link style="font-size: 17px" @click="$router.push('/contactUS')" class="fonts_family">关于晓帆互联
                      </el-link>&nbsp;&nbsp;
                      <el-link style="font-size: 17px" @click="$router.push('/contactUS')" class="fonts_family">人才招聘
                      </el-link>&nbsp;&nbsp;
                      <el-link style="font-size: 17px" @click="$router.push('/contactUS')" class="fonts_family">联系我们
                      </el-link>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <el-divider direction="vertical"></el-divider>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
                <div style="display: inline-block;margin-left: 20px">
                  <div style="font-size: 13px;font-weight: 100" class="fonts_family">晓帆互联APP</div>
                  <img src="static/images/wx.png" style="height: 65px;width:65px;margin-top: 5px">
                </div>
                <div style="display: inline-block;margin-left: 20px">
                  <div style="font-size: 13px;font-weight: 100" class="fonts_family">晓帆互联官方微信</div>
                  <img src="static/images/wx.png" style="height: 65px;width:65px;margin-top: 5px">
                </div>
              </el-col>
            </el-row>

            <hr style="border-top:1px solid #585c60;width: 100%;border-bottom: 0;"/>
            <!--            <el-row :span="24">-->
            <!--              <el-col :span="8">-->
            <!--                <div style="display: inline-block;text-align: left">-->
            <!--                  <el-link @click="$router.push('/login')">中国航天科工集团</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">商业航天高峰论坛</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">能源界</el-link>-->
            <!--                  <br/>-->
            <!--                  <el-link @click="$router.push('/login')">徐工信息汉云</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">数字化企业网</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">硅谷网</el-link>-->
            <!--                </div>-->
            <!--              </el-col>-->
            <!--              <el-col :span="10">-->
            <!--                <div style="display: inline-block;margin-left: 20px;text-align: left">-->
            <!--                  <el-link @click="$router.push('/login')">五金网</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">人脸识别系统</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">成分分析</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">铜陵装修</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link @click="$router.push('/login')">安徽招标网</el-link>&nbsp;&nbsp;-->
            <!--                  <br/>-->
            <!--                  <el-link>机床商务网</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link>中国军工网</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link>忽米网</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link>中国测控网</el-link>&nbsp;&nbsp;-->
            <!--                  <el-link>更多</el-link>-->
            <!--                </div>-->
            <!--              </el-col>-->
            <!--              <el-col :span="6">-->
            <!--                &nbsp;-->
            <!--              </el-col>-->
            <!--            </el-row>-->
            <el-row style="margin-top: 45px">
                         <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
                <span style="color: #b9bbc0;font-weight: 100;font-size: 13px" class="fonts_family">Copyright@2022 南京晓帆工业互联网有限公司</span>
                  <br/>
                   <span style="color: #b9bbc0;font-weight: 100;font-size: 13px" class="fonts_family"><el-link href="https://beian.miit.gov.cn/#/Integrated/index" :underline="false"> 苏ICP备2022005923号-1</el-link></span>
              </el-col>
              <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
                <span style="color: #b9bbc0;font-weight: 100;font-size: 13px" class="fonts_family">Copyright@2022 南京晓帆工业互联网有限公司
                  <br/><el-link href="https://beian.miit.gov.cn/#/Integrated/index" :underline="false">
                  苏ICP备2022005923号-1
                  </el-link>
                </span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="0" :sm="3" :md="3" :lg="3" :xl="3">
            &nbsp;
          </el-col>
        </el-row>
        <br>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import * as echarts from "echarts";
import ChinaJson from "./map/china.json"
import {queryMapMsgOne} from "../../../manage-ui/src/views/mapmsg/api/map_msg";


export default {
  name: "home",
  data() {
    return {
      form: {},
      imgList: [],
      drawer: false,
      showCheckProduct1: true,
      showCheckProduct2: false,
      showCheckProduct3: false,
      msgData: [
        {
          isShow: false,
          msgImg: "msgImg1",
          msgbackground: "msgbackground",
          img: "static/images/bottom1_img.png",
          title: "安全生产",
          message: "面向化工、钢铁等行业,提供融合国家系列安全信息化指南文件，覆盖人、物、环、管等要素的标准应用服务和整体解决方案，有效解决安全管理的繁杂低效难题，助力企业筑牢安全防线。"
        },
        {
          isShow: false,
          msgImg: "msgImg1",
          msgbackground: "msgbackground",
          img: "static/images/bottom2_img.png",
          title: "低碳节能",
          message: "基于实时精准的采集服务，提供覆盖设备配置、数据采集、碳排核算、能耗分析、能效分析的企业能耗监测和碳排管理应用服务和拓展工具集，助力企业绿色转型。"
        },
        {
          isShow: false,
          msgImg: "msgImg1",
          msgbackground: "msgbackground",
          img: "static/images/bottom3_img.png",
          title: "设备管理",
          message: "面向工业企业生产设备管理的用户，帮助工业企业解决设备巡检、设备保修、设备保养等管理难题，提升企业设备管理效率，同时，通过数据实时采集，诊断分析，洞察设备状态，实现预测性维修。"
        },
        {
          isShow: false,
          msgImg: "msgImg1",
          msgbackground: "msgbackground",
          img: "static/images/bottom4_img.png",
          title: "制造可视化",
          message: "通过与企业现有的生产系统、OA系统、ERP系统、CRM系统、物流系统等业务系统的对接，实现数据集成，建立订单、物料使用、生产、仓储、运输的全生命周期管理和可视化分析，提高生产经营效率。"
        },
      ],
      showProduct: false,
      userInfo: {},
    }
  },
  mounted() {
    this.userInfo = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : {};
    this.drawCharts();
    this.queryMapMsgOne();
  },
  methods: {
    goToManage() {
      // if (this.userInfo || this.userInfo.userType==='0'){
      //   this.$router.push({path: "/manageDeveloper"})
      // }
      if (this.userInfo.userType === '1') {
        this.$router.push({path: "/management"})
      }
    },
    queryMapMsgOne() {
      queryMapMsgOne().then(res => {
        let form = res.data.mapMsg;
        if (form) {
          this.form = JSON.parse(form);
        }
      });
    },
    handleCommand(command) {
      if (command === 'logout') {
        sessionStorage.clear()
        this.$router.push({path: "/login"})
      }
    },
    checkProduct(item) {
      if (item === 0) {
        this.showCheckProduct1 = true
        this.showCheckProduct2 = false
        this.showCheckProduct3 = false
      }
      if (item === 1) {
        this.showCheckProduct2 = true
        this.showCheckProduct1 = false
        this.showCheckProduct3 = false
      }
      if (item === 2) {
        this.showCheckProduct3 = true
        this.showCheckProduct2 = false
        this.showCheckProduct1 = false
      }
    },
    showProducts(item) {
      if (item === true) {
        this.showProduct = false;
      } else {
        this.showProduct = true;
      }
    },
    showMsg(item) {
      this.msgData[item].msgImg = "msgImg";
      this.msgData[item].msgbackground = "msgbackground1";
      this.msgData[item].isShow = true;
    },
    closeMsg(item) {
      this.msgData[item].msgImg = "msgImg1";
      this.msgData[item].msgbackground = "msgbackground";
      this.msgData[item].isShow = false;
    },
    drawCharts() {
      var chinaMap = echarts.init(document.getElementById("china-map"));
      var chinaMapPhone = echarts.init(document.getElementById("china-map-phone"));
      echarts.registerMap("china", ChinaJson);
      // 基于准备好的dom，初始化echarts实例
//      window.onresize = chinaMap.resize; // 窗口或框架被调整大小时执行chinaMap.resize
      chinaMap.setOption({
        tooltip: {
          trigger: ''
        },
        geo: { // 这个是重点 —— 这里设置为地图的阴影
          map: 'china', // 表示中国地图
          roam: false, // 禁止拖拽
          label: { // 标志信息
            normal: {
              show: false, // 是否显示对应地名
              textStyle: {
                color: '#CFF6FF',
              }
            }
          },
          silent: true, // 禁止hover效果
          zoom: 1.1, // 地图比例
          center: [105.194115019531, 35.982111640625], // 地图中心位置， 此处的纬度与下面的center相差1度是形成阴影的距离，可自己随意调整
          itemStyle: {
            normal: {
              borderColor: 'transparent'
            },
            emphasis: {
              show: false
            }
          }
        },
        series: [
          {
            name: '',
            type: 'map',
            zoom: 1.1,
            zlevel: 1,
            mapType: 'china',
            center: [105.194115019531, 35.582111640625],
            roam: false,
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: true
              }
            },
            data: [
              {"name": "德州"},
              {"name": "潍坊",},
              {"name": "合肥",},
              {"name": "福州",},
              {"name": "焦作",},
              {"name": "宁波",},
              {"name": "盐城",},
              {"name": "武汉",},
              {"name": "广州",},
              {"name": "贵州",},
              {"name": "成都",},
            ],
            itemStyle: {
              normal: {
                borderColor: '#99afd0',
                areaColor: 'rgba(241,248,253,0.85)'
              },
              emphasis: {
                areaColor: '#b7c6d5',
                color: '#717171',
                borderWidth: 0,
                show: false,
              }
            },
          }
        ]
      });
      chinaMapPhone.setOption({
        tooltip: {
          trigger: ''
        },
        geo: { // 这个是重点 —— 这里设置为地图的阴影
          map: 'china', // 表示中国地图
          roam: false, // 禁止拖拽
          label: { // 标志信息
            normal: {
              show: false, // 是否显示对应地名
              textStyle: {
                color: '#CFF6FF',
              }
            }
          },
          silent: true, // 禁止hover效果
          zoom: 1.1, // 地图比例
          center: [105.194115019531, 35.982111640625], // 地图中心位置， 此处的纬度与下面的center相差1度是形成阴影的距离，可自己随意调整
          itemStyle: {
            normal: {
              borderColor: 'transparent'
            },
            emphasis: {
              show: false
            }
          }
        },
        series: [
          {
            name: '',
            type: 'map',
            zoom: 1.1,
            zlevel: 1,
            mapType: 'china',
            center: [105.194115019531, 35.582111640625],
            roam: false,
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: true
              }
            },
            data: [
              {"name": "德州"},
              {"name": "潍坊",},
              {"name": "合肥",},
              {"name": "福州",},
              {"name": "焦作",},
              {"name": "宁波",},
              {"name": "盐城",},
              {"name": "武汉",},
              {"name": "广州",},
              {"name": "贵州",},
              {"name": "成都",},
            ],
            itemStyle: {
              normal: {
                borderColor: '#99afd0',
                areaColor: 'rgba(241,248,253,0.85)'
              },
              emphasis: {
                areaColor: '#b7c6d5',
                color: '#717171',
                borderWidth: 0,
                show: false,
              }
            },
          }
        ]
      });
      var dataValue = this.dealWithData();
      var data1 = dataValue.splice(0, 20);
      var option = {
        tooltip: {
          trigger: 'item',
          formatter(value) {
            return value.data.name + "<br/>";
          },
        },
        series: [
          {
            type: "map",
            map: "china",
            roam: false,
            silent: true,//禁止点击省份效果
            zoom: 1.1,
            center: [105.194115019531, 35.582111640625],
            // geoIndex: 1,
            // aspectScale: 0.75, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                areaColor: "#fcfcff",
                borderColor: "#309bfb",
                borderWidth: 0.5
              },
              emphasis: {
                areaColor: "#e9f4ff",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 5,
                borderWidth: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          },
          {
            name: "",
            type: "scatter",
            coordinateSystem: "geo",
            data: dataValue,
            symbol: "circle",
            symbolSize: 8,
            hoverSymbolSize: 10,
            encode: {
              value: 2
            },
            label: {
              formatter: "{b}",
              position: "right",
              show: false
            },
            itemStyle: {
              color: "#309bfb"
            },
            emphasis: {
              label: {
                show: false
              }
            }
          },
          {
            name: "Top 5",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: data1,
            symbolSize: 15,
            encode: {
              value: 2
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
              color: "#309bfb",
              period: 9,
              scale: 5
            },
            hoverAnimation: true,
            label: {
              formatter: "{b}",
              position: "right",
              show: true
            },
            itemStyle: {
              color: "#309bfb",
              shadowBlur: 2,
              shadowColor: "#333"
            },
            zlevel: 1
          }
        ]
      };
      chinaMap.setOption(option);
      chinaMapPhone.setOption(option);
    },
    dealWithData() {
      var geoCoordMap = {
        合肥: [117.27, 31.86],
        武汉: [114.31, 30.52],
        南京: [118.80, 32.06],
        广州: [113.27, 23.14],
        宁波: [121.63, 29.87],
        盐城: [120.17, 33.36],
        贵阳: [106.71, 26.60],
        成都: [104.08, 30.66],
        福州: [119.30, 26.08],
        焦作: [113.25, 35.22],
        德州: [116.37, 37.44],
        潍坊: [119.17, 36.71],
        沧州: [116.85, 38.31],
        巴彦淖尔: [107.39, 40.75],
        深圳: [114.06, 22.55],
        连云港: [119.23, 34.60],

        // 海门: [121.15, 31.89],
        // 鄂尔多斯: [109.781327, 39.608266],
        // 招远: [120.38, 37.35],
        // 舟山: [122.207216, 29.985295],
        // 齐齐哈尔: [123.97, 47.33],
        // 昆明: [102.73, 25.04],
        // 长治: [113.08, 36.18],
        // 深圳: [114.07, 22.62],
        // 咸阳: [108.72, 34.36],
        // 银川: [106.27, 38.47],
        // 张家港: [120.555821, 31.875428],
        // 呼和浩特: [111.65, 40.82],
        // 成都: [104.06, 30.67],
        // 张家界: [110.479191, 29.117096],
        // 宜兴: [119.82, 31.36],
        // 扬州: [119.42, 32.39],
        // 常州: [119.95, 31.79],
        // 重庆: [106.54, 29.59],
        // 台州: [121.420757, 28.656386],
        // 南京: [118.78, 32.04],
        // 无锡: [120.29, 31.59],
        // 克拉玛依: [84.77, 45.59],
        // 马鞍山: [118.48, 31.56],
        // 北京: [116.46, 39.92],
        // 徐州: [117.2, 34.26],
        // 乌鲁木齐: [87.68, 43.77],
        // 杭州: [120.19, 30.26],
        // 开封: [114.35, 34.79],
        // 济南: [117, 36.65],
        // 哈尔滨: [126.63, 45.75],
        // 唐山: [118.02, 39.63],
        // 荆州: [112.239741, 30.335165],
        // 义乌: [120.06, 29.32],
        // 洛阳: [112.44, 34.7],
        // 秦皇岛: [119.57, 39.95],
        // 石家庄: [114.48, 38.03],
        // 常德: [111.69, 29.05],
        // 湘潭: [112.91, 27.87],
        // 长沙: [113, 28.21],
        // 大庆: [125.03, 46.58]
      };
      var data = [];
      for (var key in geoCoordMap) {
        data.push({name: key, value: geoCoordMap[key]});
      }
      return data;
    }
  }
}
</script>

<style scoped>
.backgroundImg {
  background-image: url('../../static/images/background.png');
  background-size: 100% 100%;
  /*height: 21%;*/
}

.home_main {
  font-family: Source Han Sans CN, sans-serif;
  font-weight: 400;
  padding: 0 0 0 0;
}

.fonts_family {
  font-family: Source Han Sans CN, sans-serif;
  font-weight: 400;
}

.btn {
  border: none;
  outline: none;
  height: 80px;
  font-size: 14px;
  line-height: 30px;
  font-family: Source Han Sans CN, sans-serif;
  font-weight: 400;
  color: white;
  background-color: rgba(255, 255, 255, 0);
}

.productbtn {
  color: #000000;
  font-size: 20px;
  font-weight: 400;
  border: none;
  outline: none;
  height: 60px;
  font-family: Source Han Sans CN, sans-serif;
  line-height: 30px;
  background-color: rgba(255, 255, 255, 0);
}

.carousel_bottom {
  height: 128px;
  background-color: rgba(0, 0, 0, 0.4);
  text-align: center;
}

.carousel_bottom .carousel_bottom_item {
  color: white;
  display: inline-block;
  font-size: 18px;
  font-weight: 400;
  font-family: Source Han Sans CN, sans-serif;
  line-height: 17px;
  margin-right: 55px;
  margin-left: 55px;
  cursor: pointer;
}

.map_img {
  height: 68px;
  width: 110px;
}

.map_font {
  font-size: 27px;
  font-family: Source Han Sans CN, sans-serif;
  font-weight: 400;
  color: #0875F9;
  line-height: 44px;
}

.topFont {
  margin-top: 10px;
  font-family: Source Han Sans CN, sans-serif;
  font-weight: 400;
}

.msgImg {
  margin-top: 30px;
}

.msgFont {
  margin-bottom: 20px;
  letter-spacing: 1px;
  color: white;
  padding: 7px 10px 0 20px;
  text-align: left;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}

.msgImg1 {
  margin-top: 100px;
}

.msgbackground {
  position: absolute;
  width: 16.667%;
  height: 350px;
  background-color: rgba(33, 20, 20, 0.5);
}

.msgbackground1 {
  position: absolute;
  width: 16.667%;
  height: 350px;
  background-image: url('../../static/images/home_msg_background.png');
}

.support_bottom {
  font-family: Source Han Sans CN, sans-serif;
  font-weight: 400;
  background-color: #303030;
}

.home_bottom {
  /*height: 618px;*/
  background-image: url('../../static/images/background2.png');
  background-size: 100% 100%;
  text-align: center;
}

.home_feet {
  background-image: url('../../static/images/background3.png');
  background-size: 100% 100%;
  text-align: center;
}

.el-divider--vertical {
  height: 3em;
  width: 0.3mm;
}
</style>

<style>
.el-carousel_item .el-carousel__container {
  height: 315px;
}

.el-carousel_item .el-carousel__button {
  background-color: #0aa4f8;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue